export enum Priority {
	VeryHigh = 1,
	High = 2,
	Normal = 3,
	Low = 4,
	VeryLow = 5,
}

export type PriorityConfig = {
	priority: Priority;
	name: string;
	color: string;
	icon: string;
	priorityId: number;
}

export const getPriority = (p: number): Priority => {
	switch (p) {
		case 1: return Priority.VeryHigh;
		case 2: return Priority.High;
		case 3: return Priority.Normal;
		case 4: return Priority.Low;
		case 5: return Priority.VeryLow;

		default: return Priority.Normal;
	}
}

export const getPriorityColor = (p: Priority): string => {
	switch (p) {
		case Priority.VeryHigh: return "red";
		case Priority.High: return "orange";
		case Priority.Normal: return "amber";
		case Priority.Low: return "green";
		case Priority.VeryLow: return "blue";

		default: return "white";
	}
}

export const getPriorityIcon = (p: Priority): string => {
	switch (p) {
		case Priority.VeryHigh: return "mdi-chevron-double-up";
		case Priority.High: return "mdi-chevron-up";
		case Priority.Normal: return "mdi-minus";
		case Priority.Low: return "mdi-chevron-down";
		case Priority.VeryLow: return "mdi-chevron-double-down";

		default: return "";
	}
}

export const getPriorityText = (p: Priority): string => {
	switch (p) {
		case Priority.VeryHigh: return "Very High";
		case Priority.High: return "High";
		case Priority.Normal: return "Normal";
		case Priority.Low: return "Low";
		case Priority.VeryLow: return "Very Low";

		default: return "";
	}
}

export const getPriorityConfig = (p: Priority): PriorityConfig => ({
	priority: p,
	name: getPriorityText(p),
	color: getPriorityColor(p),
	icon: getPriorityIcon(p),
	priorityId: p.valueOf(),
})

export const getPriorityConfigById = (p: number): PriorityConfig => getPriorityConfig(getPriority(p))


